import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

export const adminApi = axios.create({ baseURL: ADMIN_API });

// Attach token from localStorage on every request
adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("kl_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auto-redirect to /admin/login on 401, and swallow the rejection so it never
// surfaces as an "unhandled error" in the React overlay (the page is about to
// navigate away anyway).
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("kl_admin_token");
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
      // Never-resolving promise → suppresses the rejection cascade while we redirect.
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);

export const isAdmin = () => !!localStorage.getItem("kl_admin_token");
